import React from 'react';

/** Bootstrap Components */
import { Container, Row, Col, Form, Button, Card, Modal } from 'react-bootstrap';

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';

import { LOGIN_URL } from '../utils/constants';

import { sha256 } from 'js-sha256';
import { withRouter } from '../utils/withRouter'; // <--- custom wrapper for React Router v6

class LoginComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            passwd: '',
            show: false,
            disable: false
        };
    }

    handleClose = () => {
        this.setState({ show: false, disable: false });
    }

    onChangeUsername = (event) => {
        this.setState({ username: event.target.value });
    }

    onChangePasswd = (event) => {
        this.setState({ passwd: event.target.value });
    }

    generate = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 5; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    };

    login = async (event) => {
        event.preventDefault();  // <--- IMPORTANT
        
        const { username, passwd } = this.state;

        if (!username || !passwd) {
            alert("Provide valid login details!");
            return;
        }

        let s = this.generate();
        let pw = s + sha256(sha256(passwd) + s);

        const data = JSON.stringify({ un: username, pd: pw });

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Checksum': sha256(data)
            },
            body: JSON.stringify({ data: btoa(data) })  // <--- corrected
        };

        try {
            const res = await fetch(LOGIN_URL, requestOptions);
            const json = await res.json();

            if (json.STATUS === 0) {
                localStorage.setItem('token', json.TOKEN);
                localStorage.setItem('FORCE_UPDATE', username.trim() === passwd.trim() ? 1 : 0);

                this.props.router.navigate('/home');  // <--- React Router v6 navigate
            } else {
                alert(json.MESSAGE);
                this.setState({ passwd: '' });
            }
        } catch (err) {
            alert("Login failed. Check server.");
			// this.props.router.navigate('/home');  // <--- React Router v6 navigate
            console.error(err);
        }
    }

    render() {
        return (
            <div>
                <NavbarComponent />
                <header className="App-common main">
                    <Container className='login-form'>
                        <Row className="p-5">
                            <Col className="col-sm-8 col-md-4 col-lg-4 offset-md-3 offset-lg-3">
                                <Card>
                                    <Card.Body>
                                        <Form onSubmit={this.login}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Username</Form.Label>
                                                <Form.Control type="text" placeholder="Enter username"
                                                    onChange={this.onChangeUsername} />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control type="password" placeholder="Password"
                                                    onChange={this.onChangePasswd} />
                                            </Form.Group>

                                            <Button variant="primary" type="submit">Submit</Button>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </header>

                <FooterComponent />

                <Modal size="sm" centered show={this.state.show}>
                    <Modal.Body style={{ textAlign: 'center' }}>
                        <p>Please wait...</p>
                        <div className='loader'></div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default withRouter(LoginComponent);
